import React from 'react';

interface Definition {
  term: string;
  definition: string;
}

interface DefinitionsSectionProps {
  content: string;
}

const DefinitionsSection: React.FC<DefinitionsSectionProps> = ({content}) => {
  // Parse the content into term-definition pairs
  const definitions: Definition[] = content
    .split('\n\n')
    .filter((line) => line.trim())
    .map((line) => {
      // Format: **Term**: Definition
      const match = line.match(/^\*\*(.+?)\*\*:\s*(.+)$/);
      if (match) {
        return {
          term: match[1],
          definition: match[2],
        };
      }
      return null;
    })
    .filter((def): def is Definition => def !== null);

  return (
    <>
      {/* Mobile/Tablet: Card-based layout */}
      <div className="lg:hidden space-y-4">
        {definitions.map((def, idx) => (
          <div
            key={idx}
            className="border border-subtleGrey rounded-lg p-4 hover:bg-surfaceGrey transition-colors">
            <div className="font-semibold text-headlineGrayscale mb-2">
              {def.term}
            </div>
            <div className="text-headlineGrayscale leading-relaxed">
              {def.definition}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop: Table layout */}
      <div className="hidden lg:block overflow-x-auto -mx-6 lg:-mx-12">
        <div className="inline-block min-w-full px-6 lg:px-12">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-subtleGrey">
                <th className="text-left py-3 px-4 font-semibold text-headlineGrayscale w-1/3">
                  Term
                </th>
                <th className="text-left py-3 px-4 font-semibold text-headlineGrayscale">
                  Definition
                </th>
              </tr>
            </thead>
            <tbody>
              {definitions.map((def, idx) => (
                <tr
                  key={idx}
                  className="border-b border-subtleGrey hover:bg-surfaceGrey transition-colors">
                  <td className="py-4 px-4 font-semibold text-headlineGrayscale align-top">
                    {def.term}
                  </td>
                  <td className="py-4 px-4 text-headlineGrayscale leading-relaxed">
                    {def.definition}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default DefinitionsSection;
